import React from 'react';
import classnames from 'classnames';
import { Link } from 'gatsby';
// import { graphql, useStaticQuery } from 'gatsby';
// import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import Icon from 'components/UI/Icon';
import POSSvg from 'images/Home/Cloud/home-cloud-pos.svg';
import * as styles from './cloud.module.scss';

// TODO: пример статической картинки
// <StaticImage
//   src='images/hero-bg-tablet.png'
//   alt=""
//   placeholder="blurred"
//   layout="fixed"
// />

const Cloud = ({ data }) => {
  // const {
  //   allFile: { nodes },
  // } = useStaticQuery(graphql`
  //   query getCloudLogosImages {
  //     allFile(filter: { relativeDirectory: { eq: "Home/Cloud/Logos" } }) {
  //       nodes {
  //         name
  //         relativePath
  //         childImageSharp {
  //           gatsbyImageData(placeholder: BLURRED, formats: [AUTO, WEBP, AVIF])
  //         }
  //       }
  //     }
  //   }
  // `);

  return (
    <section className={classnames(styles.section)}>
      <div className="cr-wrap">
        <div className={classnames(styles.inner)}>
          <div className={classnames(styles.flexContainer)}>
            <div className={classnames(styles.content)}>
              <p
                className={classnames(
                  styles.subtitle,
                  'cr-text-3 cr-subheader cr-opacity-05'
                )}
              >
                {data.subtitle}
              </p>
              <h2 className={classnames(styles.title, 'cr-white cr-h2')}>
                {data.title && data.title}
              </h2>
              <p
                className={classnames(
                  styles.description,
                  'cr-reg cr-white cr-opacity-05'
                )}
              >
                {data.description}
              </p>
              <Link
                to={data.btnUrl.uri}
                className={classnames(
                  styles.link,
                  'cr-btn cr-btn--icon cr-btn--icon-arrow cr-btn--wide cr-btn--large cr-btn--icon-red-txt cr-btn--icon-red-txt_white-bg'
                )}
              >
                {data.btnText}
                <Icon name="corner-arrow-small-bold" />
              </Link>
            </div>
            <div className={classnames(styles.graphics)}>
              <img src={POSSvg} alt="" />
            </div>
          </div>
          <ul className={classnames(styles.logos)}>
            {data.logos?.map((logo, i) => (
              <li key={i}>
                <img src={logo.cloudLogoImage?.sourceUrl} alt="" />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Cloud;
